import moment from "moment";

export default class DateHelper {
  static format(date: number): string {
    let d = new Date(date * 1000);
    return d.toLocaleDateString();
  }
  static formatStringDate(date: string): string {
    if (date) {
      let d = new Date(+date * 1000);
      return d.toLocaleDateString();
    } else {
      return "";
    }
  }
  static formatAssignmentDate(date: string): string {
    return moment
      .unix(+date)
      .utc()
      .format("MM.DD.YY");
  }
  static formatDate(date: Date) {
    return moment(date).format("YYYY-MM-DD");
  }
  static formatReportDate(date: Date) {
    return moment(date).format("MM/DD/YYYY");
  }
  static formatNumberDate(date: number): string {
    return moment
      .unix(+date)
      .utc()
      .format("MM/DD/YYYY");
  }
}
